<template>
    <highcharts  class="chart w-full h-full" :options="options" :ref="chartId" id="chartId"></highcharts>
</template>

<script>
    import {reduceBigNumbers} from '../main.js'
    import {numberFormat} from '../main.js'
    let data = {}
    const moment = require('moment')

    export default {
        props: ['data', 'chartId','periodStock','daysEstimated'],
        data() {
            return {
                options: {
                    chart: {
                        //   type: 'areaspline',
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        backgroundColor:'rgba(255,255,255,0)',
                        spacingBottom: 0,
                        marginTop: 4,
                    },
                    title: {
                        text: ''
                    },
                    subtitle: {
                        text: ''
                    },
                    credits:{
                        enabled: false
                    },

                    legend: {
                        margin: 1,
                        itemStyle: {
                            color: '#fff',
                            fontWeight: 'thin',
                            fontSize: '10px'
                        }
                    },

                    xAxis: {
                        tickWidth: 0,
                        lineColor: 'rgba(255,255,255,0)',
                        min: 1,
                        max:  this.data.length-1,
                        labels: {
                            align: 'center'
                        },
                    },
                    yAxis: [
                        {
                            gridLineColor: 'rgba(255, 255, 255, .1)',
                            min: 1,
                           // max: 100,
                            width: '100%',
                            labels: {
                            format: '{value} %'
                        },
                        title: {
                        text: 'Stock',
                        },
                        },
                    ],

                    plotOptions: {
                        series: {
                            marker: {
                                enabled: false,
                            },
                            fillOpacity: 0.5
                        },
                        area:{
                            fillOpacity:.1,
                            lineWidth:3,
                            marker:{
                                enabled:false
                            },
                            shadow: {
                                offsetX: 2,
                                offsetY: 4,
                                opacity: .2,
                                width: 4,
                            }
                        },
                        line:{
                            lineWidth:2,
                            marker:{
                                enabled:false
                            },
                            shadow: {
                                offsetX: 1,
                                offsetY: 2,
                                opacity: .1,
                                width: 2,
                            }
                        }
                    },

                    series: [
                        {
                            type: 'area',
                            name: 'Velocidad real',
                            //data: this.data,
                            color:'#3DFFFF',
                            data: []
                        },
                        {
                            name: 'Velocidad ideal',
                            dashStyle: 'dash',
                            color: "#90ed7d",
                            data: [
                                { x: 1, y: 100},
                                { x: this.periodStock, y: 0}
                            ]
                        },
                        {
                            name: 'Velocidad estimada',
                            dashStyle: 'dash',
                            color: "#b74646",
                            data: [
                                { x: 1, y: 100},
                                { x:  this.daysEstimated, y: 0}
                            ]
                        }
                    ]
                }
            }
        },
        methods: {
            updateData(){
                let chart = this.$refs[this.chartId].chart;
                chart.series[0].setData(this.data)
            }
        },
        watch: {
            data: {
                handler(a, b){
                    this.updateData();
                },
                deep: true
            },
        },
        mounted() {
            this.updateData();
        }
    };
</script>
<style lang="css">

    .highcharts-container{
        height: 100% !important;
        width: 100% !important;
    }

</style>
